// extracted by mini-css-extract-plugin
var _1 = "active-Yh5EY";
var _2 = "la-kqSzq";
var _3 = "lr-QCHrf";
var _4 = "pages-IuQYX";
var _5 = "ra-Wa3rX";
var _6 = "rr-eYLJo";
var _7 = "slider-pyRaf";
var _8 = "slides-LRQSy";
var _9 = "wrapper-ZPT47";
export { _1 as "active", _2 as "la", _3 as "lr", _4 as "pages", _5 as "ra", _6 as "rr", _7 as "slider", _8 as "slides", _9 as "wrapper" }
